import { Component, Input } from "@angular/core";

@Component({
  selector: "snoots-page-detail-tag",
  template: "",
  standalone: false
})
export class PageDetailTagComponent {
  @Input() title: string | undefined;
  @Input() color: string | undefined;
  @Input() textColor: string | undefined;
}
